import { Plus } from 'lucide-react';

import { Button } from '@/components/atoms/button';
import { cn } from '@/lib/utils';

interface FloatingActionButtonProps {
  onClick: () => void;
  className?: string;
}

export function FloatingActionButton({ onClick, className }: FloatingActionButtonProps) {
  return (
    <Button
      onClick={onClick}
      size="lg"
      className={cn(
        'fixed bottom-6 right-6 z-40 size-14 rounded-full shadow-lg',
        'bg-primary hover:bg-primary/90 text-primary-foreground',
        'flex items-center justify-center p-0',
        'animate-in fade-in slide-in-from-bottom-4 duration-300',
        className
      )}
    >
      <Plus className="size-6" />
      <span className="sr-only">Nouvelle campagne</span>
    </Button>
  );
}
